export type AccessType = "SUPER_SCOPE" | "ORG_SCOPE" | "PERMANENT" | "TEMPORARY";
export type TabKey = "all" | "permanent" | "temporary" | "sandbox";

export interface AdAccount {
  id: string;
  organizationId: string;
  organizationName: string | null;
  metaAccountId: string;
  name: string;
  currency: string | null;
  timezoneName: string | null;
  accountStatus: number | null;
  sandbox: boolean;
  createdAt: string;
  cachedSpendMonthCents: number | null;
  cachedSpendCurrency: string | null;
  cachedCampaignCount: number | null;
  lastSyncedAt: string | null;
  pinned: boolean;
  pinSortOrder: number | null;
  accessType: AccessType;
  grantExpiresAt: string | null;
  needsReauth: boolean;
}

export interface Organization {
  id: string;
  name: string;
  emailDomain: string;
}

export function formatMoneyCents(cents: number | null | undefined, currency: string | null | undefined): string {
  if (cents == null) return "—";
  const value = cents / 100;
  const display = value >= 1000
    ? `${(value / 1000).toFixed(1)}k`
    : value.toFixed(2);
  return `${currency ?? ""} ${display}`.trim();
}

export function formatRelative(iso: string | null | undefined): string {
  if (!iso) return "从未同步";
  const diffMs = Date.now() - new Date(iso).getTime();
  if (diffMs < 0) return "刚刚";
  const m = Math.floor(diffMs / 60000);
  if (m < 1) return "刚刚";
  if (m < 60) return `${m} 分钟前`;
  const h = Math.floor(m / 60);
  if (h < 24) return `${h} 小时前`;
  const d = Math.floor(h / 24);
  return `${d} 天前`;
}

export function formatDate(iso: string | null | undefined): string {
  if (!iso) return "";
  return new Date(iso).toISOString().slice(0, 10);
}
